/** Sidebar layout constants shared with breadcrumbs and main layout. */

export const SIDEBAR_WIDTH = 260;

/** Maps child routes to their sidebar section for breadcrumbs. */
export const NAV_SECTION_BY_PATH: Record<string, string> = {
  "/merge-requests": "Engineering",
  "/development": "Engineering",
  "/projects": "Engineering",
  "/system-health": "Operations",
};
